import axios from "axios";
import qs from "qs";
import {Toast} from "vant";

axios.defaults.timeout = 5000; // 超时时间
const debug = true;
const baseURL = debug ? 'https://yylt.1lwork.com/api/' : 'https://yylt.1lwork.com/api/';

//http request 拦截器
axios.interceptors.request.use(
    (config) => {
      if (config.url === "https://geo.datav.aliyun.com/areas_v3/bound/geojson") {
        config.headers = {
          "Content-Type": "application/x-www-form-urlencoded",
        };
        return config
      }else{
        config.headers = {
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
        };
        config.data = qs.stringify(config.data);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
);

//响应拦截器即异常处理
axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (err) => {
      if (err && err.response) {
        switch (err.response.status) {
          case 400:
            console.log("错误请求");
            break;
          case 401:
            console.log("未授权，请重新登录");
            break;
          case 403:
            console.log("拒绝访问");
            break;
          case 404:
            console.log("请求错误,未找到该资源");
            break;
          case 405:
            console.log("请求方法未允许");
            break;
          case 408:
            console.log("请求超时");
            break;
          case 500:
            console.log("服务器端出错");
            break;
          case 501:
            console.log("网络未实现");
            break;
          case 502:
            console.log("网络错误");
            break;
          case 503:
            console.log("服务不可用");
            break;
          case 504:
            console.log("网络超时");
            break;
          case 505:
            console.log("http版本不支持该请求");
            break;
          default:
            console.log(`连接错误${err.response.status}`);
        }
      } else {
        console.log("连接到服务器失败");
      }
      return Promise.resolve(err.response);
    }
);

/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
        .get(baseURL + url, {
          params: params,
        })
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            resolve(response.data);
          } else {
            Toast(response.data.msg);
          }
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */

export function post(url, data = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios.post(baseURL + url, data, config).then(
        (response) => {
          console.log(response, "response");
          if (response.status === 200) {
            resolve(response.data);
          } else {
            Toast(response.data.msg);
          }
        },
        (err) => {
          reject(err);
        }
    );
  });
}


export function geoJson(adcode, isCity) {
  return new Promise((resolve, reject) => {
    let data;
    if (isCity) {
      data = {code: adcode}
    } else {
      data = {code: adcode + "_full"}
    }
    axios.get("https://geo.datav.aliyun.com/areas_v3/bound/geojson", {
      params: data,
    }).then(
        (response) => {
          console.log(response, "response");
          if (response.status === 200) {
            resolve(response.data);
          } else {
            Toast(response.data.msg);
          }
        },
        (err) => {
          reject(err);
        }
    );
  });
}